import type { DeepPartial } from '@luna/utils-ts';

import type { OwnTransfer } from './OwnTransfer';

export const HR: DeepPartial<OwnTransfer> = {};
